const VerticalLayout = () => import('@/layouts/VerticalLayout')

const facilityProfile = () => import('./views/facilityProfile')

export default [
  {
    path: '/facility',
    name: 'facility',
    component: VerticalLayout,
    meta: { auth: true },
    children: [{
      path: '',
      name: 'facility',
      component: facilityProfile,
      meta: { name: 'profile', userType: 'provider', serviceTypes: 'all' }
    }]
  }
]
